import { Observable } from 'rxjs';
import {
  VesselHotoForm,
  VesselHotoFormDraftBody,
  VesselHotoFormSubmitBody,
  VesselHotoFormType,
  VesselHotoSetList,
} from '../entities/vessel-hoto-form.entity';

export abstract class VesselHotoFormRepository {
  /** `setNo` omitted = the latest set. */
  abstract getForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    setNo?: number | null
  ): Observable<VesselHotoForm>;

  abstract getSets(vesselActivityId: number): Observable<VesselHotoSetList>;

  abstract startNewSet(vesselActivityId: number): Observable<VesselHotoSetList>;

  abstract submitForm(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormSubmitBody
  ): Observable<void>;

  abstract saveDraft(
    vesselActivityId: number,
    formType: VesselHotoFormType,
    body: VesselHotoFormDraftBody
  ): Observable<void>;
}
